module.exports = __webpack_public_path__ + "static/media/david.782d21cc.jpg";